import { render, staticRenderFns } from "./detail_yhmc.vue?vue&type=template&id=de92a680&scoped=true"
import script from "./detail_yhmc.vue?vue&type=script&lang=js"
export * from "./detail_yhmc.vue?vue&type=script&lang=js"
import style0 from "./detail_yhmc.vue?vue&type=style&index=0&id=de92a680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de92a680",
  null
  
)

export default component.exports